import { FULL_DAYS_OF_WEEK_TRANSLATIONS, MILLISECONDS_PER_DAY } from '@app/constants/constants';
import { TranslationLanguageCode } from '@app/enum/translation-language-code.enum';
import { ShiftDate } from '@app/model/shift-date.model';
import * as moment from 'moment';

export function formatMonth(date: Date): string {
    return date.toString().split(' ')[1];
}

export function addMonths(date: Date, months: number): Date {
    const day = date.getDate();
    date.setMonth(date.getMonth() + months);
    if (date.getDate() != day) date.setDate(0);
    return date;
}

export function subtractMonths(months: number): Date {
    const today = new Date();
    const day = today.getDate();
    today.setMonth(today.getMonth() - months);
    if (today.getDate() != day) today.setDate(0);
    return today;
}

export function compareYearsAndMonths(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return d1.getFullYear() == d2.getFullYear() && d1.getMonth() == d2.getMonth();
}

export function localISOTime(date: Date): string {
    return localISODateAndTime(date).slice(0, -1).split('T')[0];
}

export function localISODateAndTime(date: Date): string {
    var tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
    return new Date(date.getTime() - tzoffset).toISOString();
}

export function isShiftInPast(shift: ShiftDate): boolean {
    return new Date(shift.shiftTimes[0].start) < new Date();
}

export function convertDateToUTC(date: Date): Date {
    date = new Date(date);
    const offsetMinutes = date.getTimezoneOffset();
    return new Date(date.getTime() - offsetMinutes * 60 * 1000);
}

export function getWeekdayFromDate(date: Date): string {
    return FULL_DAYS_OF_WEEK_TRANSLATIONS[date.getDay() - 1];
}
export function formatPerformanceDate(date: Date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
}

export function getWeekdayFromDay(day: number): string {
    return FULL_DAYS_OF_WEEK_TRANSLATIONS[day];
}

export function areDatesEqual(dateOne: Date, dateTwo: Date): boolean {
    return (
        dateOne.getDate() == dateTwo.getDate() &&
        dateOne.getMonth() == dateTwo.getMonth() &&
        dateOne.getFullYear() == dateTwo.getFullYear()
    );
}

export function isDateIsBeforeOrEqualAnotherDate(dateOne: Date, dateTwo: Date): boolean {
    const date1 = new Date(new Date().setFullYear(dateOne.getFullYear(), dateOne.getMonth(), dateOne.getDate()));
    const date2 = new Date(new Date().setFullYear(dateTwo.getFullYear(), dateTwo.getMonth(), dateTwo.getDate()));

    return date1.getTime() <= date2.getTime();
}

export function getWeekNumber(date: Date) {
    const tempDate = moment(date);
    const weekNumber = tempDate.isoWeek();

    return weekNumber;
}

export function getDateFormatByTranslationLanguageCode(code: string): string {
    switch (code) {
    case TranslationLanguageCode.EN:
        return 'DD.MM.YYYY';
    case TranslationLanguageCode.HU:
        return 'YYYY.MM.DD';
    default:
        return 'DD.MM.YYYY';
    }
}

export function getUTCFromDate(date: Date): number {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}

export function getDayDifference(date1: Date, date2: Date = new Date()) {
    const utc1 = getUTCFromDate(date1);
    const utc2 = getUTCFromDate(date2);

    const diffInMins = Math.abs(utc2 - utc1);

    return Math.floor(diffInMins / MILLISECONDS_PER_DAY);
}

export function getNumberOfWeekendDays(fromDate: Date, endDate: Date): number {
    let weekendDayCount = 0;

    while (fromDate < endDate) {
        fromDate.setDate(fromDate.getDate() + 1);
        if (fromDate.getDay() === 0 || fromDate.getDay() === 6) {
            ++weekendDayCount;
        }
    }

    return weekendDayCount;
}

export function compareDates(date1: Date, date2: Date) {
    return date1.getTime() - date2.getTime();
}

export function isDateTypeValid(date: Date) {
    return date instanceof Date && !isNaN(date.getTime());
}

export function isDateValid(date: string, format: string = null): boolean {
    return format ? date && moment(date, format, true).isValid() : date && !isNaN(Date.parse(date));
}

export function getDatesBetween(start: string, end: string): Date[] {
    const arr = [];
    for (const dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
    }
    return arr;
}
